var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkills8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "etvoZMJQnRd1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170 160",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "11df1ac055be410fba607665f6b93dd3",
    "export-id": "38d2437abf964b6b9198dd63915cda68",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd53-fill",
    x1: 493.885,
    y1: 575.496,
    x2: 512.245,
    y2: 575.496,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd53-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd53-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd54-fill",
    x1: 479.884,
    y1: 548.592,
    x2: 543.758,
    y2: 548.592,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd54-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd54-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd59-fill",
    x1: 762.953,
    y1: 511.408,
    x2: 742.838,
    y2: 472.322,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd59-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd59-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd60-fill",
    x1: 680.665,
    y1: 510.813,
    x2: 739.888,
    y2: 510.813,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd60-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd60-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd61-fill",
    x1: 727.708,
    y1: 468.863,
    x2: 782.201,
    y2: 555.282,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd61-fill-0",
    offset: "32.5%",
    stopColor: "#d15050"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd61-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd62-fill",
    x1: 805.117,
    y1: 491.485,
    x2: 735.943,
    y2: 606.313,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd62-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd62-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd64-fill",
    x1: 577.761,
    y1: 511.66,
    x2: 660.342,
    y2: 403.344,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd64-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd64-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd66-fill",
    x1: 739.955,
    y1: 524.338,
    x2: 716.621,
    y2: 492.755,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd66-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd66-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd69-fill",
    x1: 697.37,
    y1: 518.593,
    x2: 678.144,
    y2: 492.57,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd69-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd69-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd72-fill",
    x1: 701.168,
    y1: 550.126,
    x2: 680.434,
    y2: 522.028,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd72-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd72-fill-1",
    offset: "85.6%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd73-fill",
    x1: 766.5,
    y1: 492.732,
    x2: 751.441,
    y2: 459.443,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd73-fill-0",
    offset: "12.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd73-fill-1",
    offset: "52.9%",
    stopColor: "#ed956e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd75-fill",
    x1: 641.167,
    y1: 484.535,
    x2: 679.861,
    y2: 516.742,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd75-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd75-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd76-fill",
    x1: 686.802,
    y1: 481.386,
    x2: 708.15,
    y2: 497.784,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd76-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd76-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd87-fill",
    x1: 693.597,
    y1: 496.593,
    x2: 704.856,
    y2: 510.523,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd87-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd87-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd90-fill",
    x1: 677.857,
    y1: 534.899,
    x2: 687.87,
    y2: 547.817,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd90-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd90-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd98-fill",
    x1: 655.802,
    y1: 502.034,
    x2: 665.269,
    y2: 513.771,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd98-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd98-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd103-fill",
    x1: 754.219,
    y1: 500.997,
    x2: 732.2,
    y2: 483.609,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd103-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd103-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd106-fill",
    x1: 701.925,
    y1: 429.363,
    x2: 659.584,
    y2: 433.743,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd106-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd106-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd172-fill",
    x1: 640.063,
    y1: 733.951,
    x2: 717.552,
    y2: 733.951,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd172-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd172-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etvoZMJQnRd177-fill",
    x1: 677.382,
    y1: 578.004,
    x2: 742.28,
    y2: 578.004,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd177-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "etvoZMJQnRd177-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.311832 0 0 0.282834-107.994504-71.244751)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.889054 0 0 1.39027 40.209054-264.398185)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-380.533659 2.506774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960.9,662.6l-234-.2.1-37.4l233.9.1v37.5Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.8,777.5l-234-.2.1-120.3l234,.2-.1,120.3Z",
    fill: "#faf2ec"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M759.4,694.3h-18.1v-18.1h18.1v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.1,694.3h-18.1v-18.1h18.1v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.8,694.3h-18.1l.1-18.1l18,.1v18Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.5,694.3h-18v-18h18.1l-.1,18Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.3,694.4h-18.1v-18.1h18.1v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893,694.4h-18.1v-18.1h18.1v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.7,694.4h-18v-18.1h18v18.1Z",
    fill: "#f09280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.5,694.4h-18.1v-18.1l18.1.1v18Z",
    fill: "#f09280"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M759.3,726.5h-18v-18.1h18v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.1,726.5h-18.1v-18.1l18.1.1v18Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.8,726.6l-18.1-.1v-18h18.1v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.5,726.6h-18.1l.1-18.1h18v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.3,726.6h-18.1v-18.1h18.1v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893,726.6h-18.1v-18.1h18.1v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.7,726.6h-18.1v-18.1l18.1.1v18Z",
    fill: "#f09280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.4,726.7l-18-.1v-18h18.1l-.1,18.1Z",
    fill: "#f09280"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M759.3,758.7h-18.1v-18h18.1v18Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786,758.8l-18-.1v-18h18v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.8,758.8h-18.1v-18.1h18.1v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.5,758.8h-18.1v-18.1h18.1v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.2,758.8h-18v-18.1h18v18.1Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893,758.8h-18.1v-18h18.1v18Z",
    fill: "#e5d1ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.7,758.9l-18.1-.1v-18h18.1v18.1Z",
    fill: "#f09280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.4,758.9h-18.1l.1-18.1h18v18.1Z",
    fill: "#f09280"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M754.7,637.8c0,4.3-3.5,7.7-7.8,7.7s-7.8-3.5-7.8-7.7c.1-4.3,3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M746.9,641c-1.6,0-3-1.3-3-3v-25.1c0-1.6,1.4-3,3-3c1.7,0,3,1.4,3,3v25.1c0,1.7-1.3,3-3,3Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M776.2,637.8c0,4.3-3.4,7.7-7.7,7.7s-7.8-3.4-7.8-7.7s3.5-7.8,7.8-7.8s7.7,3.5,7.7,7.8Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M768.5,641q0,0,0,0c-1.7,0-3-1.3-3-3v-25c0-1.7,1.3-3,3-3q0,0,0,0c1.7,0,3,1.3,3,3v25c0,1.7-1.4,3-3,3Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M927.1,637.9c0,4.3-3.5,7.8-7.8,7.8-4.2,0-7.7-3.5-7.7-7.8s3.5-7.8,7.8-7.8s7.7,3.5,7.7,7.8Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M919.4,641.1c-1.7,0-3.1-1.3-3.1-3l.1-25c0-1.7,1.3-3,3-3q0,0,0,0c1.6,0,3,1.3,3,3v25c0,1.7-1.4,3-3,3Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M948.7,637.9c0,4.3-3.5,7.8-7.8,7.8s-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M940.9,641.2c-1.7,0-3-1.4-3-3.1v-25c0-1.7,1.4-3,3-3c1.7,0,3,1.3,3,3v25.1c0,1.6-1.3,3-3,3Z",
    fill: "#625153"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M509.2,575.5c-4.9.5-9,.7-12,4.4-2.9,3.7-4.8,22.4-1.8,23.6c3,1.3,6-6.9,6-6.9l10.8-2.5-3-18.6Z",
    fill: "url(#etvoZMJQnRd53-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.1,605.1c-3.6-5.5-8.9-24.1-11.1-26.8-2.2-2.8-9.4-2.9-9.4-2.9s-6.5-6.2-10.5-12.4c-4.1-6.2-9.1-15.2-12.8-14.3-3.7.8,3.5,12.7,6.4,18.7c3,6,11.9,19.9,9.1,23.7s-7.6.5-13.3-1.7c-5.8-2.2-10.9-4-12.3-2-1.5,2.1,2.9,4.4,12.3,10.5c9.3,6.1,13.7,11.3,19.5,15.5c5.9,4.2,10.8,18.6,10.8,18.6l21-13-9.7-13.9Z",
    fill: "url(#etvoZMJQnRd54-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M649.5,587.6c-24.9,9.2-61.6,70.8-61.6,70.8l-44.5-51c0,0-18,4.9-29.7,19.3c0,0,39.3,96.9,76.4,99.1c35.7,2.2,62.4-58,62.4-58l-3-80.2Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M592,727.3q-1,0-2,0c-37.5-2.3-75.3-95.3-76.9-99.2-.3-.8.1-1.6.8-1.9.8-.3,1.6.1,1.9.8.4.9,38.6,95.3,74.4,97.4c34.2,2.1,60.8-56.5,61-57.1.4-.8,1.2-1.1,1.9-.8.7.4,1.1,1.2.7,1.9-1,2.5-26.6,58.9-61.8,58.9Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.866783 0 0 1.00935 92.925655-4.783992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M730.2,498.2q.1-.1.1-.2.1,0,.1-.1.5-.8,1.1-1.5.5-.7,1.1-1.4.6-.6,1.1-1.3.6-.6,1.2-1.2q1.3-1.2,2.9-2q1.5-.9,3.2-1.2c2.5-.6,4.6.3,6.2,1.8c1.5,1.6,2.5,3.8,2.8,6.1.6,4.2-1.5,9.2-4.9,12.7s-8.1,5.5-12.6,3.5q-.9-.4-1.7-1-.7-.6-1.2-1.5c-.5-.9-.9-1.8-1.1-2.9-.2-1-.3-2-.3-3.1q0-1.8.6-3.5.5-1.7,1.4-3.2Z",
    fill: "url(#etvoZMJQnRd59-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.9,586q-.4-.1-.9-.3-.4-.2-.8-.4c-.1,1.3-.7,2.4-1.6,3.4-.8,1-1.8,1.9-2.8,2.6-2.5,1.9-5.2,3.6-8,4.9-2.8,1.4-5.8,2.3-8.9,2.8-5.4.8-10.7,0-15.9-1.6-5.1-1.7-10.1-4.3-14.8-7-.8-.6-1.7-1.1-2.6-1.7-.8-.6-1.6-1.3-2.2-2.1-.3-.4-.5-.9-.6-1.4s-.1-1-.1-1.4q-.1-.8,0-1.6t.3-1.5c0,0,.1-.5.2-.9.2-.5.3-.9.3-1c.7-1.5,1.1-2.3,1.4-3.1.3-.7.6-1.5,1-2.8s.7-2.6.9-4c.3-1.4.5-2.8.6-4.1q.1-.2.1-.3t0-.2q.3-1.6.3-3.3.1-1.6,0-3.2c-.1-2,.3-2.7,1.2-2.8.9-.2,2.2,0,3.9-.3c1.7-.2,3.4-.9,5-1.7s3.1-1.8,4.5-2.9c2.8-2,5.3-4.3,7.7-6.7c2.4-2.3,4.7-4.8,6.9-7.4c2.1-2.2,4.1-4.5,5.9-6.9c1.7-2.5,3.2-5.1,4.2-8c.4-1.2.2-4,.5-6.4.3-2.3.9-4.3,2.9-3.8.2,0,.1,4.7,0,9.5s-.3,9.9-.3,10.7c-.1,3.4,0,7,.2,10.5.1,3.6.4,7.1.7,10.5.5,4.1,1.4,8.2,2.6,12.2s2.7,8,4.2,12.1q.9,2.5,1.9,4.9t2.1,4.7Z",
    fill: "url(#etvoZMJQnRd60-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.9,576.4q-.1,0-.2.1q0,0-.1,0c-5.4,1.1-10.9,1.5-16.3,1.1-5.4-.3-10.8-1.4-15.9-3.2q-4-1.3-7.6-3.2-3.7-1.9-7.1-4.2-.7-.5-1.6-1.1-.9-.5-1.7-1.1.1-.2.1-.3t0-.2q.3-1.6.3-3.3.1-1.6,0-3.2c-.1-2,.3-2.7,1.2-2.8.9-.2,2.2,0,3.9-.3c1.7-.2,3.4-.9,5-1.7s3.1-1.8,4.5-2.9c2.8-2,5.3-4.3,7.7-6.7c2.4-2.3,4.7-4.8,6.9-7.4c2.1-2.2,4.1-4.5,5.9-6.9c1.7-2.5,3.2-5.1,4.2-8c.4-1.2.6-3.9,1.3-6.1.7-2.3,1.8-4.1,3.7-3.6.2,0,0,4.5-.3,9.2-.2,4.6-.6,9.5-.6,10.4q-.1,5,0,10q.2,5.1.7,10.1c.4,4.2,1.2,8.5,2.2,12.7c1,4.3,2.3,8.5,3.8,12.6Z",
    fill: "url(#etvoZMJQnRd61-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.1,486q-.1,1-.3,2t-.5,1.9c-.4,1.6-.9,3.2-1.3,4.9s-.7,3.4-.8,5.5c-.2,3.3-.5,8.7-1,14.7-.4,5.9-1,12.4-1.6,17.8q-.1.6-.2,1.2q0,.7-.1,1.3c-.1.8-.2,1.6-.3,2.3-.2.8-.5,1.5-1,2.1-.4.6-.9,1.1-1.5,1.6-.5.5-1,1-1.5,1.4-3.5,3.5-7.7,7.2-12.4,10.4s-9.8,5.8-14.8,7.1q-1.1.3-2.2.5t-2.2.3q-.1,0-.3,0-.1,0-.2,0-.9.1-1.9.1-.9,0-1.8,0l-.4-.1h-.4q-.1,0-.2,0q0,0-.1,0-.2-.1-.5-.1t-.6-.1q-.1,0-.3-.1-.2,0-.4-.1-.1,0-.2-.1-.1,0-.2,0-.6-.1-1.1-.3t-1-.5c-.8-.4-1.5-1-2.2-1.6s-1.3-1.3-2-1.9q-1.3-1.3-2.5-2.6t-2.4-2.6q-2.4-2.8-4.5-5.7t-3.9-6c-1.6-2.6-3.1-5.2-4.1-7.9-1-2.8-1.5-5.6-1.2-8.8.3-2.2.6-4.6.7-6.9s.2-4.7-.1-7q-.1-1.3-.3-2.5-.3-1.2-.6-2.3c-.5-1.8-1.1-3.5-1.6-5.2-.6-1.7-1.2-3.4-1.7-5.2q-.6-2-.9-4t-.3-4.1c0-3.2.4-6.6,1.1-10c.7-3.5,1.8-6.8,3.3-9.8q.3-.6.5-1.1.3-.6.6-1.1.7-1.1,1.8-1.9q1-.8,2.3-1.4.5-.1,1.1-.3.5-.2,1.1-.3.3-.1.6-.2.3,0,.6-.1t.6-.1q.3-.1.7-.1t.8-.1q.5-.1.9-.1.3-.1.6-.1t.5-.1q.9,0,1.8-.1.8-.1,1.6-.2q5.6-.8,11.2-1.5t11.3-1.2c2.8-.3,5.7-.3,8.6-.1s5.7.5,8.6.6q.6.1,1.2.1.6.1,1.1.1.3.1.7.2.3,0,.7.1t.8.2q.5.1.9.2.9.3,1.8.6t1.8.6q1.2.6,2.4,1.3q1.3.6,2.4,1.4.4.4.9.7.4.4.8.7c1.2,1.1,2,1.9,2.6,2.9.6.9.9,2,1,3.5l.1.5v.4c.3,2.7.3,5.4.2,8.1-.1,2.8-.4,5.5-.7,8.3Z",
    fill: "url(#etvoZMJQnRd62-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M731.8,485.9q-.2,1-.3,2t-.2,2c-.4,1.6-.9,3.2-1.3,4.9s-.7,3.4-.8,5.5c-.2,3.3-.5,8.7-1,14.7-.4,5.9-1,12.4-1.6,17.8q-.1.6-.2,1.2q0,.7-.1,1.3c-.1.8-.2,1.6-.3,2.3-.2.8-.5,1.5-1,2.1-.4.6-.9,1.1-1.5,1.6-.5.5-1,1-1.5,1.4-3.5,3.5-7.7,7.2-12.4,10.4s-9.8,5.8-14.8,7.1q-1.1.3-2.2.5t-2.2.3q-.1,0-.3,0-.1,0-.2,0-.9.1-1.9.1-.9,0-1.8,0l-.4-.1h-.4q-.1,0-.2,0q0,0-.1,0-.2-.1-.5-.1t-.6-.1q-.1,0-.3-.1-.2,0-.4-.1-.1,0-.2-.1-.1,0-.2,0c0,0,1-.1,2.2-.2s2.7-.2,3.6-.5c2.7-.8,5.3-1.9,7.8-3.1c2.5-1.3,4.9-2.8,7.1-4.6q1.1-.8,2.1-1.8q1-.9,1.9-1.9c4.9-5.3,7.7-11.3,9.4-17.7c1.7-6.3,2.1-13.1,2.3-19.9.1-3.2,0-6.3-.3-9.4-.2-3.1-.6-6.2-1.1-9.3-.4-2.8-.8-5.6-1.4-8.4-.5-2.8-1.3-5.5-2.6-8-.5-1.2-1-2.4-1.7-3.5-.7-1-1.6-2-2.9-2.4-.9-.3-2.1-.3-3.4-.2-1.2.1-2.5.2-3.4.3-2.7.3-5.3.6-7.9.8-2.6.3-5.2.5-7.9.5q-4,0-8.1-.4-4.1-.3-8.1-1c-1.5-.3-3-.7-4.4-1.1-1.5-.4-2.9-.8-4.3-1.4-.4-.2-1.1-.4-1.9-.7s-1.6-.7-2.3-1q.3-.6.5-1.1.3-.6.6-1.1.7-1.1,1.8-1.9q1-.8,2.3-1.4.5-.1,1.1-.3.5-.2,1.1-.3.3-.1.6-.2.3,0,.6-.1t.6-.1q.3-.1.7-.1t.8-.1q.5-.1.9-.1.3-.1.6-.1t.5-.1q.9-.1,1.8-.2.8-.1,1.5-.2q5.6-.8,11.2-1.5q5.6-.6,11.3-1.2c2.8-.2,5.7-.2,8.6,0s5.8.4,8.7.6q.6.1,1.2.1.6.1,1.1.1.3.1.7.2.3,0,.7.1t.8.2q.5.1.9.2.9.3,1.8.6t1.8.6q1.2.6,2.4,1.3q1.3.6,2.4,1.4.4.4.8.7.4.4.9.7c1.1,1.1,1.9,1.9,2.5,2.8.6,1,.9,2,1,3.6l.1.4v.5c.3,2.7.2,5.4.1,8.1-.2,2.7-.5,5.5-.8,8.2Z",
    fill: "url(#etvoZMJQnRd64-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.8,493.1c-.4,1.9-.8,4.1-.9,6.2-.2,2.1,0,4.2.6,6.1.2.6.4,1.1.6,1.5.2.5.5,1,.9,1.4.8.8,1.8,1.2,2.8,1.5c1.1.3,2.2.5,3.2.8q1,.3,2,.5.9.3,1.9.4c3.7.4,7.1-1,9.7-3.3s4.5-5.5,5.1-8.5c.3-1.6.5-4.3,0-6.7-.5-2.3-1.7-4.3-4.3-4.3q-.8,0-1.6-.1-.7,0-1.5,0-1.6.1-3.1.5-1.4.3-2.9.8c-1.1.4-2.2.9-3.3,1.4-1.2.5-2.3,1-3.4,1.3-.5.2-.9.3-1.3.4-.5,0-.9-.1-1.4-.3-.3-.1-.8-.4-1.3-.6s-.9-.3-1.3-.1c-.1.1-.3.3-.3.5-.1.3-.2.5-.2.6Z",
    fill: "url(#etvoZMJQnRd66-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M692.9,507.1c.1.9.5,1.4,1.1,1.9s1.3.8,2,1.2q.1,0,.1,0q.1.1.1.1t.2,0q.2.1.5.2c.7.2,1.4.4,2.1.5.8.1,1.5.2,2.3.2q.1,0,.3,0q.1,0,.3,0q.7-.1,1.5-.1.7-.1,1.5-.2.6,0,1.2-.1.6-.2,1.1-.3q1.1-.3,2-1q.9-.6,1.5-1.5q0,0,0,0t.1,0c.7-.9,1.3-2.1,1.6-3.3.4-1.2.7-2.4.8-3.6q0-.2,0-.4q0-.3-.1-.5c0-.7-.1-1.3-.4-1.9-.3-.5-.8-.9-1.5-1.2-.9-.3-1.9-.4-2.8-.5-1,0-1.9,0-2.9.1-2.2.1-4.5.4-6.5,1.2s-3.7,2.1-4.7,4.1q-.4.7-.7,1.5-.3.7-.5,1.4-.1.5-.2.9q0,.4,0,.8q0,.1,0,.2q0,.2,0,.3Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M654.4,493.5q0,0,0,0t0,0c.5,1.8,1.1,3.5,1.7,5.2.5,1.7,1.1,3.4,1.6,5.2.2.7.3,1,.4,1.2c0,.2.1.4.4,1.2c0,0,.3.5.7,1c.3.6.6,1.1.6,1.1s0,.2.1.3c0,.1,0,.3,0,.3c1.1,1.2,2,2.3,3.1,3c1.1.8,2.3,1.2,4,1.2.9,0,1.9-.2,2.7-.5.9-.4,1.7-1,2.2-1.8.5-.7.8-1.5,1-2.4.1-.9.2-1.8.1-2.7-.2-2-.7-4.1-1.6-6.1-.8-2-1.9-3.9-3.3-5.3q-.1-.1-.4-.2-.2-.1-.5-.2-1.5-.4-3-.8-1.5-.3-3-.5c-1-.2-2.3-.4-3.5-.3-1.2,0-2.4.3-3.3,1.1Z",
    fill: "url(#etvoZMJQnRd69-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M658.3,505.4q0,.3,0,.6.1.3.1.6.1.2.2.4t.2.4c.1.5.2,1,.3,1.6.1.5.3,1,.5,1.4q0,.1.1.2q0,0,.1.1c.4.6.9,1,1.4,1.3.6.3,1.3.5,2,.7q.1.1.2.1t.3.1q.3.1.8.2.4.1.9.2c1,.2,2.2.3,3.3.2c1-.2,2.1-.5,2.8-1.2q.3-.2.5-.5t.4-.7q0-.1,0-.1q0-.1.1-.1.2-.8.2-1.7q0-.8-.3-1.6c-.2-.8-.5-1.5-1-2.2-.4-.7-.9-1.4-1.4-1.9-1-1.2-2.5-2-4.1-2.5-1.7-.4-3.4-.6-5-.5-.6,0-1.2.1-1.6.3-.5.2-.8.6-.9,1.2q-.1.4-.2.9q0,.4,0,.8t0,.9q0,.4.1.8Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.6,526.7q-1,.4-2.1.8-1.1.3-2.2.4-1.1,0-2.1.1-1.1,0-2.1-.2-.5,0-1-.1-.5-.2-1-.3c-.2-.1-.3-.1-.4-.1s-.1.1-.2.3q0,.2.1.3q0,.2,0,.4-.1-.2-.1-.4-.1-.2,0-.4c0-.4.2-.8.4-1c.1-.3.3-.5.5-.4.6.2,1.3.3,1.9.4.5.1,1,.2,1.3.2q1.4.2,2.8.1t2.8-.5q.7-.1,1.3-.3t1.3-.4c.2,0,.4-.1.7-.2s.7-.3,1.3-.8q-.2.3-.6.6-.3.2-.6.4-.5.3-1,.6-.5.2-1,.5Z",
    fill: "#ffe5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.5,527.6c.1-.2.1-.3.2-.3s.2,0,.4.1q.5.1,1,.3.5.1,1,.1q1,.2,2.1.2q1-.1,2.1-.1q1.1-.1,2.2-.4q1.1-.4,2.1-.8.5-.3,1-.5.5-.3,1-.6.3-.2.6-.4.4-.3.6-.6.1-.1.2-.2t.2-.2q.3.2.6.3.3.2.5.3c.4.3.9.5,1.4.8.5.2.9.5,1.3.8q.5.5.6,1q.1.4-.1,1c0,.3-.2.8-.3,1.2s-.2.8-.3.9c-.3.1-.8.2-1.3.2-.6,0-1.1,0-1.5,0-.8-.1-1.6.1-2.4.3s-1.5.5-2.3.8q-1,.4-2.1.7-1.1.2-2.2.3-1.1.2-2.2,0-1-.2-2-.8c-.5-.4-1.1-.9-1.5-1.5s-.7-1.3-.8-2q0-.1,0-.1q0-.1,0-.1q0-.2,0-.4-.1-.1-.1-.3Z",
    fill: "url(#etvoZMJQnRd72-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.5,529.5q.4.7,1,1.4.5.6,1.2,1.1.4.3.9.5t1,.3q-.3-.2-.5-.2-.2-.1-.3-.2-.3-.2-.7-.5-.3-.2-.6-.5t-.6-.6-.5-.7q-.4-.5-.6-1-.2-.6-.2-1.2q0-.2,0-.5.1-.2.2-.4.2-.4.4-.7.3-.3.6-.6.2-.2.4-.5t.4-.6c.3-.5.6-1.1.9-1.7s.5-1.3.7-1.8c.2-.6.3-1.2.4-1.7.2-.6.3-1.1.4-1.8q.6-2.9.5-5.7-.1-2.9-.9-5.7-.5-1.9-1.4-3.7t-2.1-3.4q-.2-.3-.4-.7-.3-.3-.5-.6-.2-.2-.5-.4-.2-.2-.5-.4q0,0,0,0-.1,0-.1,0-.1.1,0,.1q0,.1,0,.1c.7.7,1.4,1.6,2,2.5s1.1,1.8,1.5,2.8q.4.8.7,1.5.3.8.5,1.6c.6,1.6.9,3.3,1,5.1.2,1.7.1,3.5-.1,5.2-.1.6-.2,1.5-.3,2.3-.2.8-.4,1.6-.6,2.2-.3.9-.5,1.7-.8,2.5-.3.7-.7,1.5-1.3,2.2q-.2.4-.5.6-.2.3-.5.6-.2.2-.3.4-.1.3-.2.5-.1.6,0,1.2t.3,1.1Z",
    fill: "url(#etvoZMJQnRd73-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.2,455.1q1.7-1.1,3.5-1.9q1.8-.7,3.7-1.4c1.5-.4,2.9-.7,4.3-.8c1.4-.2,2.8-.2,4.4-.4-2.4-1.9-5-3.6-7.9-5s-5.9-2.4-9-2.9c.4-1.5,1.8-3.1,3.3-4.4c1.6-1.4,3.5-2.5,4.7-3.3c3.9-2.3,8-3.9,12.3-4.9c4.2-1,8.6-1.3,13.2-1.1q3.7.1,7.3.9q3.6.7,7.2,1.9c1.4.5,2.7,1.1,4,1.7c1.4.6,2.7,1.3,4,1.9c1.3.5,2.4,1.2,3.5,1.9c1.2.7,2.3,1.4,3.5,2c.8-1.3,2.1-2.4,3.7-3.2c1.5-.9,3.2-1.5,4.7-1.8q1.8-.3,3.7-.2q1.8.1,3.6.4c.8.2,2.1.5,3.4.9c1.2.4,2.3,1.1,2.6,2-2.8-.3-5.7.4-8,1.8s-4.1,3.6-4.9,6.4c2.1-.3,4.2-.3,6.2,0c2.1.3,4.1.8,6,1.6q1.2.5,2.3,1q1.1.6,2.1,1.4c.6.4,1.3.8,2,1.4.6.5,1.2,1.2,1.4,1.8-1.6-.2-3.2.3-4.5,1.3s-2.3,2.3-3,3.8c-.7,1.2-1.1,2.6-1.3,4-.3,1.4-.5,2.8-.7,4.2-.2,1.5-.5,2.9-.7,4.4-.3,1.5-.5,3-.7,4.5-.7,6.1-1.8,12.2-2.7,18.2-.9,6.1-1.4,12.1-1.1,18.4.1.8-.2,1.2-.6,1.3-.4,0-.9-.1-1.5-.3-.1,0-.4-.1-.7-.1-.3-.1-.6-.2-.6-.3q.1-1.1.2-2.3.1-1.1.1-2.2.1-1.2.1-2.3t0-2.2q0-.5,0-.9q0-.5,0-1q0-.4,0-.8t0-.8c0-4,.1-7.9,0-11.8s-.3-7.7-.9-11.7q-.1-.8-.3-1.7-.1-.9-.4-1.7q0-.1-.1-.3q0-.1-.1-.2-.1,0-.2-.1-.1,0-.2-.1-.6-.2-1.2-.4t-1.2-.4c-.2,0-.7-.1-1.1-.2-.5-.1-.9-.2-1-.4q-.1-.1-.1-.2q0,0,0-.1-.2-1.2-.3-2.3-.1-1.2-.1-2.4-.1-.7-.1-1.4-.1-.7-.1-1.4q0-.4,0-.8-.1-.5-.1-.9q0,0,0-.1t0-.2q0-.4-.1-.7q0-.4,0-.7c-1.8.9-3.8,1.5-5.9,2.1-2,.5-4.1.9-6.1,1.2-4.4.7-8.8,1.7-13.2,2.5-4.4.9-8.9,1.5-13.4,1.4q-3.3,0-6.6-.3-3.4-.2-6.7-.6c-2-.2-3.9-.7-5.8-1.3s-3.8-1.2-5.8-1.7c-1.8-.1-4,.8-6,1.9-2.1,1.1-4,2.5-5.2,3.5.8-2.6,1.9-5.1,3.4-7.4c1.5-2.2,3.4-4.2,5.8-5.7Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.9,492.1c-.6.5-1.3.5-2.1.3s-1.6-.6-2.1-.8q-1.2-.6-2.4-1.1-1.2-.6-2.4-.9-1.6-.5-3.3-.7-1.6-.3-3.3-.2-.4,0-.8.1t-.7.4c-.1.3-.2.6-.3,1c0,.4,0,.7,0,1q0,.6.1,1.2t.3,1.1q.3.4.6.8.3.3.6.6.1.1.3.2.1.1.2.1.3.2.7.3.3,0,.7.1t.9.2.9.2q.5.1,1.1.2.5.1,1,.2q1.9.5,3.8.9q1.8.5,3.7.8c.5.1,1.2.2,1.7.2.6-.1,1.2-.2,1.5-.7q.2-.3.3-.6t.1-.6c.1-.8,0-1.5-.2-2.2-.2-.8-.6-1.5-.9-2.1Z",
    fill: "url(#etvoZMJQnRd75-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.9,490c-.1.2.5.3,1.1.3s1.2,0,1.3,0c.5-.1,1.3-.2,2.1-.4s1.6-.4,2.2-.6c.9-.3,1.8-.7,2.5-.9.8-.3,1.5-.5,2.3-.7c1.9-.5,3.4-.9,4.8-1.2c1.5-.3,3-.6,5-.9.5-.1.9-.2,1.4-.2.5-.1.9-.1,1.4,0q.6.2,1.1.4t1,.4q.6.3,1.1.8.6.4,1.1.9c.7.6,1.3,1.4,1.7,2.3.5.9.8,1.8.8,2.8.1.3-.3.2-.7,0s-.8-.5-.9-.5c-1-.4-2.1-.6-3.2-.6s-2.2,0-3.2.1q-1.9.1-3.7.4-1.9.3-3.7.8c-1.2.3-2.2.5-3.2.8-.9.2-1.9.5-3.1.8-.8.3-1.6.5-2.4.7s-1.6.4-2.1.4q-.8,0-1.5-.1-.7-.2-1.4-.7-.4-.2-.7-.7-.3-.4-.5-.9c-.2-.5-.4-1.1-.6-1.7-.1-.6-.2-1.2,0-1.8Z",
    fill: "url(#etvoZMJQnRd76-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.8,510.1c.5.2,1.1.1,1.8-.1.6-.1,1.2-.4,1.6-.6q.8-.3,1.5-.8t1.3-1.2c.7-.7,1.2-1.6,1.6-2.6.4-1.1.6-2.2.5-3.2q0-.8-.2-1.4-.3-.7-.7-1.3c-.4-.5-.9-.9-1.5-1.2s-1.3-.6-1.9-.7q-1.7-.3-3.1.3-1.4.7-2.5,2.1-.4.5-.8,1-.3.5-.5,1-.1.1-.1.2-.1.1-.1.2-.1.2-.2.4t-.2.4c.4-.6.9-1.1,1.5-1.5s1.2-.6,1.9-.6q.5,0,1,.2.5.1,1,.6c.8.7,1.2,1.8,1.2,2.9c0,1.2-.3,2.3-.8,3.2-.3.6-.6,1.1-1,1.5-.3.5-.8.8-1.3,1.2Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M688.5,525.4q.3.1.5.3.3.1.6.2.2.1.4.3.2.1.4.3c.3.2.5.5.5.9.1.3,0,.7-.1,1.1q-.1.5-.3,1t-.6,1c0,0,.1-.3.2-.7s.3-.9.4-1.3c0-.2,0-.4,0-.7s0-.5-.1-.7q-.1-.2-.3-.4-.2-.1-.4-.2-.5-.3-1-.6-.5-.2-1-.5-.2-.1-.5-.3-.2-.1-.4-.2c-.1-.1-.4-.3-.5-.5-.2-.1-.3-.2-.1-.2q.5.3,1.1.6t1.2.6Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M681.3,531.1c0-.1.1-.3.3-.5.1-.1.3-.3.5-.3q.3-.3.6-.5.3-.1.7-.3c.5-.2,1-.5,1.5-.6.5-.2,1-.3,1.6-.2q.3,0,.5.2t0,.6q-.2.3-.4.4-.3.2-.6.3-.6.2-1.1.3-.6.1-1.2.2-.6,0-1.2.1t-1.2.3Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.9,507.3q0,0,0,.1t0,.1c.1.9.6,1.5,1.2,2s1.3.9,2,1.3q0,.1.1.1t.1,0t.2.1.4.2c.8.3,1.5.5,2.2.6s1.4.2,2.3.2q.1,0,.3,0q.1,0,.3,0q.5-.1,1.1-.1.5-.1,1.1-.1.1,0,.3,0q.1,0,.2,0l.1-.1h.2q.6,0,1.2-.2.5-.1,1.1-.2.4-.2.8-.4.5-.2.9-.4.8-.6,1.4-1.3.5-.8,1-1.6.2-.5.4-.9.2-.5.3-.9.2-.5.4-1q.1-.4.2-.9c.2-.7.5-1.6.5-2.3c0-.8-.2-1.6-1-2q-.4-.3-1-.4-.5-.1-1-.1-1.1-.1-2.1,0-1.1.1-2.2.3-1.5.2-3,.6-1.5.5-2.9,1-1.2.4-2.3,1-1.1.5-2,1.3c-.6.4-1.3,1-1.8,1.7-.6.7-1,1.5-1,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.9,507.2c1.2-.4,2.4-.9,3.6-1.4c1.2-.4,2.5-.8,3.8-1.1q1-.2,2.1-.4t2.2-.3q.4-.1.8-.1.4-.1.8-.1q1.7-.1,3.3,0q1.6,0,3.2.1c.1-.3.3-.7.3-1.1.1-.4,0-.8-.3-1q-.2-.1-.4-.1-.2-.1-.4-.1-2.4-.3-4.8-.3-2.5,0-4.8.5c-1.6.3-3.2.7-4.6,1.4-1.5.7-2.9,1.5-4.1,2.6-.2.2-.3.4-.4.6s-.2.5-.3.8Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.5,511.8c.5-.6.8-1.3,1-2s.3-1.4.2-2.2c-.2-1.7-1.1-3.2-2.4-4.2-1.2-1-2.9-1.5-4.7-1.4-1.4.2-2.7.8-3.7,1.7s-1.7,2.1-2,3.4q0,.1,0,.3q0,.1,0,.2c.1.8.4,1.3.9,1.8.5.4,1.1.8,1.7,1.2l.3.1.2.1q.1.1.3.2.2,0,.5.2c.8.2,1.4.4,2,.6.6.1,1.2.2,2,.2h.6.6c.5-.1.9-.1,1.3-.1s.8-.1,1.2-.1Z",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.9,507.3q1.8-.9,3.6-1.5q1.8-.7,3.8-1.1q1-.2,2.1-.4t2.2-.3c-.7-.8-1.6-1.4-2.6-1.8s-2.1-.6-3.2-.5c-1.5.2-2.8.8-3.9,1.7-1,1-1.7,2.2-2,3.5q0,.1,0,.2t0,.2Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.6,507.4q.1,1-.2,2-.2,1-.8,1.8-.1.2-.2.3-.1.2-.2.3.1,0,.3,0q.1,0,.2,0q0-.1.1-.1q0,0,0-.1.6-.9.9-2t.2-2.2c-.2-1.8-1.1-3.3-2.3-4.3-1.3-1.1-3-1.6-4.8-1.5q0,.1,0,.2.1.1.1.2c1.6-.1,3.2.4,4.4,1.4c1.2.9,2.1,2.4,2.3,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.2,508.7q0,.6.3,1.1.2.6.6,1q0,.1.1.1t.1,0t.2.1.4.2c.8.3,1.5.5,2.2.6s1.4.2,2.3.2c.8-.4,1.4-1,1.9-1.7.4-.8.6-1.6.5-2.5-.1-1.2-.7-2.2-1.6-2.9-.8-.6-1.9-1-3.1-.9-1.2.2-2.3.7-3,1.6-.7.8-1.1,1.9-.9,3.1Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.1,505.5c0,.2-.1.5-.2.8c0,.3-.1.6,0,.8c0-.1.2-.4.4-.6.2-.3.4-.5.5-.6q.3-.2.6-.4t.6-.4c.4-.2.7-.5,1.1-.8.3-.3.7-.6,1.1-.8.9-.4,1.9-.7,2.9-.9s2.1-.3,3.1-.4q1.2-.1,2.5-.1t2.6,0q1.3-.1,2.5-.2q1.3-.1,2.5-.3c.1-.8,0-1.6-.3-2.3-.3-.6-.8-1.2-1.7-1.5s-1.8-.4-2.8-.5c-.9,0-1.9,0-2.9.1-2.2.1-4.5.4-6.5,1.2s-3.7,2.1-4.8,4.1q-.3.7-.7,1.4-.3.7-.5,1.4Z",
    fill: "url(#etvoZMJQnRd87-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M692.9,507c0,0,.5-.4,1.2-.9.6-.5,1.3-1.1,1.6-1.4q.6-.5,1.3-.7.7-.3,1.5-.6.7-.2,1.4-.4t1.4-.3c.7,0,1.2-.1,1.8-.2.5,0,1.1,0,1.7.1q.9,0,1.9.2q1,.1,1.9.2q1,.2,1.9.3t1.9-.1q.4-.1.7-.4.4-.3.6-.6c0-.1.2-.5.3-.9.1-.3.2-.7.1-.7q-.9.2-1.9.2-.9.1-1.9,0-1.6,0-3.1-.1-1.6,0-3.2.1-1.5.1-3.1.5-1.5.3-2.9,1-.8.4-1.6.9-.7.5-1.4,1.1c-.3.3-.8.8-1.3,1.3-.4.5-.8,1-.8,1.4Z",
    fill: "#020102"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M699.1,536.4c0,0-.6.8-1.9,1.9-1.2,1.1-3,2.4-5.3,3.6q-1.2.7-2.5,1.1-1.3.5-2.8.8c-.7.1-2.4.1-4.1,0-1.7,0-3.5-.2-4.6-.3.4,0,1,.3,1.9.6.8.3,1.9.7,3.1.9c1,.2,2.2.3,3.4.4c1.2,0,2.4-.1,3.4-.3c1-.3,2.5-.7,4.2-2c1.6-1.2,3.5-3.3,5.2-6.7Z",
    fill: "url(#etvoZMJQnRd90-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.2,504.4q-.1.4,0,.7.2.3.5.4.4.2.7,0q.3-.1.4-.5.2-.3,0-.6-.1-.4-.5-.5-.3-.1-.6,0-.4.2-.5.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.3,505.6q0,.1.1.2q0,.1,0,.3.1.4.2.9q0,.5.2.9v.2l.1.1v.1.1c0,0,.1.2.1.4.1.2.1.5.2.6q.1.3.1.5.1.2.2.4.1.5.3.9.3.4.6.8c.3.4.8.7,1.3.9.5.3,1,.5,1.5.6q.2.1.3.1t.2.1q.2,0,.3.1.1,0,.3.1.2,0,.5.1t.6.1q.1,0,.1,0q.1.1.2.1.2,0,.4,0q.2.1.5.1t.6,0q.3.1.5,0q.2.1.3.1t.2-.1q1,0,1.8-.3.9-.3,1.6-.9.3-.2.4-.5.2-.2.3-.4t.1-.4q.1-.1.2-.4c.3-1.2.1-2.3-.3-3.2-.4-1-1.2-1.9-2-2.6q-.9-.7-1.8-1.2-1-.5-2-.8c-1-.4-2.2-.8-3.3-.9-1.2-.1-2.4.1-3.4.5q-.4.1-.7.3t-.6.5c-.2.3-.3.5-.3.8c0,.2.1.5.1.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.5,505.6q-.1.1-.1.1t0,.1c-.1.3,0,.7.1,1c.1.4.2.8.3,1.1v.2l.1.3q.5,0,1.1,0q.5.1,1,.1q1.4.1,2.8.2q1.4.2,2.8.4.6.2,1.2.3.6.2,1.2.4q1,.2,1.8.6.9.5,1.8,1q0,0,.1-.5.1-.4.1-1.4-.1-.5-.2-.9-.2-.4-.5-.7-.5-.8-1.2-1.3t-1.5-.9c-1.2-.6-2.4-1.1-3.6-1.5-1.3-.3-2.6-.4-3.8-.4q-.6.1-1.2.2t-1.1.4c-.2.1-.5.3-.7.5s-.4.5-.5.7Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668,514.4c.3-.6.6-1.2.8-1.8.2-.7.3-1.3.2-2q0-.2,0-.4-.1-.2-.1-.3-.1-.3-.2-.6-.1-.2-.2-.5-.1-.1-.2-.2q0-.1-.1-.3-.2-.3-.5-.6-.2-.3-.5-.5-.1-.1-.2-.2t-.3-.2-.3-.2q-.2-.1-.4-.2t-.4-.2q-.3-.1-.5-.2-.3-.1-.6-.1-.3-.1-.5-.1-.3,0-.6,0t-.6,0q-1.2.1-2.2.7t-1.7,1.5l-.1.1c.1.3.2.8.3,1.2.2.4.3.9.4,1.1q.1.3.2.6.2.2.3.5.1.1.2.2.2.1.4.2.2.3.6.5.3.3.8.5.2,0,.4.1t.4.2l.7.2.8.3q.3.1.6.2.2.2.5.2.4.1.7.1.2.1.5.1.4,0,.7.1.4,0,.7,0Z",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.8,507.9v.2l.1.3q.5,0,1.1,0q.5.1,1,.1q1.4.1,2.8.2q1.4.2,2.7.4h.1q.6.2,1.2.3.6.2,1.2.4q0-.3-.2-.6-.1-.2-.2-.5q0-.1-.1-.2-.1-.2-.2-.3-.2-.3-.4-.6-.3-.3-.6-.5-.1-.2-.2-.2-.1-.1-.3-.2-.1-.2-.3-.3t-.4-.2-.5-.2q-.2-.1-.5-.2-.2,0-.5-.1t-.6-.1-.6,0-.6,0c-.8.1-1.6.4-2.3.8s-1.3.9-1.7,1.5Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.8,507.9v.2l.1.2q0,0,.1-.1.1-.2.3-.4c.3-.4.9-.8,1.5-1.2.6-.3,1.3-.6,2.1-.6q.2-.1.5-.1.3.1.6.1.4.1.9.2.4.1.8.3.4.1.8.4t.7.6q.1.1.2.2t.2.2q.5.5.8,1.1.2.5.4,1.2.1.5.1,1t-.1,1-.3.9q-.1.4-.4.8-.1.1-.1.2-.1.1-.2.3q0,0,.1,0q.2,0,.3-.1t.2-.3q.1-.1.2-.3.3-.5.5-1.2.1-.6.1-1.3q0-.4-.1-.8q0-.4-.1-.8-.1-.1-.1-.3q0-.1-.1-.2q0-.1,0-.2-.1,0-.1-.1-.3-.6-.7-1.1t-1-.9q-.3-.3-.8-.5-.4-.3-.9-.4-.3-.1-.6-.2t-.7-.1q-.3,0-.6,0t-.6,0c-.8.1-1.6.4-2.3.8s-1.3.9-1.7,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.7,511q.3.6.6.9.3.4.5.5.3.3.7.5.4.1.8.3.2.1.5.2.2,0,.4.1t.3.1.2.1q.2,0,.3.1.1,0,.3.1.2,0,.5.1t.6.1q.1,0,.1,0q.1.1.2.1.8-.6,1.2-1.5.4-.8.3-1.9q0-.4-.2-.9-.2-.4-.5-.8c-.3-.5-.9-.9-1.4-1.2-.6-.2-1.3-.3-2-.3q-.6.1-1.1.3t-1,.6q-.1.2-.3.3-.1.1-.3.3-.1.2-.2.3-.1.2-.2.4t-.1.4q-.1.2-.1.4-.1.1-.1.2t0,.2Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.3,504.9q0,.2,0,.4t0,.3t0,.2t0,.1c.1.3.4.4.7.4.3-.1.7-.2.9-.2q.5-.1,1-.1t1-.1q1,0,2,.1t2,.2c1,.2,2.1.4,3.2.7c1,.4,2,.8,2.8,1.6c0,0,.2.1.4.3.2.1.4.2.4.3c0,0,0,0,0-.2c0-.1-.1-.3-.2-.6q-.3-1.2-.9-2.2t-1.4-1.9c-1.1-1.2-2.6-2-4.2-2.5-1.6-.4-3.4-.6-5-.5-.6,0-1.2.1-1.6.4-.5.2-.8.6-.9,1.2q-.1.5-.2,1.1q0,.5,0,1Z",
    fill: "url(#etvoZMJQnRd98-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M672.7,509.1q-.3-.2-.6-.4-.3-.1-.6-.2-.3-.2-.6-.3-.3-.2-.6-.3-.5-.2-1-.4-.5-.1-1.1-.3c-1.2-.2-2.3-.3-3.3-.3-1.1-.1-2.2,0-3.3,0q-.6,0-1.3,0-.7-.1-1.4-.3-.2,0-.4-.1t-.3-.3q-.2-.1-.3-.3q0-.1-.1-.3-.2-.2-.3-.4t-.2-.4q0-.1-.1-.2q0-.1,0-.3c0,0-.1-.1-.1-.2s0-.2,0-.2q.3.2.7.3.4.2.8.2q1.3.2,2.6.3t2.5.2q1,.1,1.9.3q1,.2,1.9.5.9.2,1.8.6.8.4,1.6.9.4.3.8.6.3.4.7.8c0,0,.1.1.2.2s.1.2.1.3Z",
    fill: "#020102"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M665.6,508.5q-.1.4,0,.7.2.3.5.4.4.1.7,0t.5-.5q.1-.3-.1-.7-.1-.3-.5-.4-.3-.1-.6,0-.3.2-.5.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.4,424c-1.8.6-3.1,1.2-4.2,2-1.2.7-2.1,1.7-3.1,2.9s-1.8,2.5-2.4,3.9-.9,2.9-.7,4.5c0-.7.4-1.5.8-2.2s.8-1.4,1.2-2q.5-1,1.2-1.9.6-.9,1.2-1.8c.9-1.2,1.8-2.2,2.7-3.1c1-.8,2.1-1.6,3.3-2.3Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.8,493.6c-.2-2-1.6-2.9-3.3-3.1s-3.6.4-4.8,1.4q-.5.5-1,1t-.9,1.1c-.2.3-.3.8-.3,1.2s.2.8.7,1c.4.1.8,0,1.3-.1s.9-.2,1.3-.3q.8,0,1.6.1.7,0,1.5.1c.5.1.9.1,1.3.1.5-.1.9-.2,1.3-.5.4-.2.8-.5,1-.9.3-.3.5-.7.3-1.1Z",
    fill: "url(#etvoZMJQnRd103-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.3,502.6c.4-.6.9-1.1,1.5-1.5s1.2-.6,1.9-.6c.5-.3,1.2-.2,1.7.1.6.3,1.1.8,1.5,1.2.3.5.7,1.1.9,1.7.2.7.3,1.3.2,1.9c0,.5-.1,1.2-.2,1.9-.2.6-.5,1.3-1,1.5.8-.3,1.6-.9,2.3-1.6s1.2-1.6,1.6-2.4q.5-1,.5-2.1t-.3-2.2c-.3-.9-.8-1.5-1.5-2-.7-.4-1.5-.7-2.4-.7-1.3,0-2.5.4-3.5,1s-1.9,1.5-2.6,2.6q-.1.1-.1.2-.1.1-.1.2-.1.2-.2.4t-.2.4Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.5,435.3q.1.2.1.5-.1.2-.3.6-.5.6-.9,1.2-.5.5-1.1,1-1.1.8-2.3,1.4-1.3.6-2.5,1.1-.6.3-1.2.4-.7.2-1.3.2c-.4,0-.7-.1-1.1-.2-.3-.2-.6-.3-1-.4q-2.3-.8-4.6-1.5t-4.7-1.2c-1.6-.3-3.3-.4-4.9-.4s-3.2.1-4.8.5c2.5-.2,5,0,7.5.6c2.4.6,4.8,1.5,7,2.8q.2.2.4.4.3.2.4.4c.4.9-.5,1.4-1.7,1.6-1.1.2-2.4.2-2.8.2-1-.1-2-.3-3-.5-.9-.3-1.9-.6-2.8-.8-2.8-.7-5.5-1.3-8.2-1.7-2.8-.4-5.5-.6-8.4-.6.2,0,.5-.1.7-.2.3-.2.5-.3.7-.4q.4-.2.9-.4.4-.2.9-.3.9-.4,1.7-.7.9-.3,1.8-.5q3-.8,6.1-1.4q3-.7,6.1-1-2-.3-4.1-.2-2,0-4,.3-1.1.1-2.1.2-1,.2-2,.3-.3.1-.6.1-.2.1-.5.1c-.1,0-.3.1-.4.1-.2.1-.4.1-.5.1-.2-.1-.2-.2-.1-.3.1-.2.3-.3.4-.4q.4-.3.8-.5.5-.3.9-.5.9-.5,1.8-.8.9-.4,1.9-.7q1.1-.4,2.2-.6q1.1-.3,2.2-.6c2.3-.5,4.6-.9,6.9-1.2c2.3-.2,4.6-.3,6.9-.1q3.3.4,6.5,1.2t6.2,2.1q.3.2.6.3.2.2.3.4Z",
    fill: "url(#etvoZMJQnRd106-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M696.3,510.9c0,0,.1.1.2.2.2.1.4.3.5.3.9.3,1.6.6,2.3.7.8.1,1.5.2,2.5.1.8,0,1.8-.1,2.8-.2s1.9-.3,2.8-.5q1-.4,1.8-1.1t1.4-1.6c-.7.4-1.4.7-2.1.9-.6.3-1.2.4-1.5.5q-1.7.4-3.4.6-1.7.3-3.5.3-.8,0-1.7,0-.8-.1-1.7-.1q0,0-.2,0-.1,0-.2-.1Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.7,514.2q-1.2.1-2.5,0t-2.5-.3c-.7-.2-1.6-.5-2.4-.8-.9-.4-1.7-.9-2.2-1.5q.4.6.8,1.1t.9,1c.4.2.8.4,1.3.6.4.1.9.2,1.3.2q.7.2,1.5.2.8.1,1.5,0q.6-.1,1.2-.3.5-.1,1.1-.2Z",
    fill: "#ea8e67"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M766.4,595.1c-14.6-8.4-36.6-14.4-36.6-14.4l-42.5-2c0,0-21.9,1.8-37.6,8.9-4.3,2-15.3,43.1-17.3,67.3s-3,122.6-3,122.6h132.5c0,0,.5-59.3.5-80.6c0-21.2,4-101.8,4-101.8Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M629.4,777.8q0,0,0,0c-.8,0-1.4-.7-1.4-1.5c0-1,1-97.5,3-121.5.3-3.6.7-7.6,1.4-12c.1-.8.9-1.3,1.7-1.2.7.1,1.3.9,1.1,1.6-.6,4.4-1.1,8.3-1.4,11.8-1.9,23.9-2.9,120.4-3,121.3c0,.8-.6,1.5-1.4,1.5Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M557.7,324.6c-1.1,0-2-.9-2-2v-17.4c0-1.1.9-2,2-2s2,.9,2,2v17.4c0,1.1-.9,2-2,2Z",
    fill: "#a8c7bf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M566.4,315.9h-17.4c-1.1,0-2-.9-2-2s.9-2,2-2h17.4c1.1,0,2,.9,2,2s-.9,2-2,2Z",
    fill: "#a8c7bf"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M912.2,578.1c-1.1,0-2-.9-2-2.1v-17.4c0-1.1.9-2,2-2s2,.9,2,2v17.4c0,1.2-.9,2.1-2,2.1Z",
    fill: "#ffcf83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M920.9,569.3h-17.4c-1.1,0-2-.9-2-2s.9-2,2-2h17.4c1.1,0,2,.9,2,2s-.9,2-2,2Z",
    fill: "#ffcf83"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M382.9,578.1c-1.1,0-2-.9-2-2.1v-17.4c0-1.1.9-2,2-2s2,.9,2,2v17.4c0,1.2-.9,2.1-2,2.1Z",
    fill: "#ffcf83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M391.6,569.3h-17.4c-1.1,0-2-.9-2-2s.9-2,2-2h17.4c1.1,0,2,.9,2,2s-.9,2-2,2Z",
    fill: "#ffcf83"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M595.9,378.2c-1.1,0-2-.9-2-2v-17.4c0-1.1.9-2,2-2s2,.9,2,2v17.4c0,1.1-.9,2-2,2Z",
    fill: "#d25a5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M604.6,369.5h-17.4c-1.1,0-2-.9-2-2s.9-2,2-2h17.4c1.1,0,2,.9,2,2s-.9,2-2,2Z",
    fill: "#d25a5a"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M810.3,587.3c-1.1,0-2-.9-2-2.1v-17.4c0-1.1.9-2,2-2s2,.9,2,2v17.4c0,1.2-.9,2.1-2,2.1Z",
    fill: "#d25a5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M819,578.5h-17.4c-1.1,0-2-.9-2-2s.9-2,2-2h17.4c1.1,0,2,.9,2,2s-.9,2-2,2Z",
    fill: "#d25a5a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M500.5,361.3c0,3.9-3.1,7-7,7s-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7Z",
    fill: "#ffcf83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.7,417.1c0,2.6-2.1,4.7-4.7,4.7s-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7Z",
    fill: "#d25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,488.1c0,2.6-2.1,4.7-4.7,4.7s-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7Z",
    fill: "#a8c7bf"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.78485 0 0 0.720575 217.039832-33.707969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.4,698.3c0,43.7-33.4,79.2-74.6,79.2s-74.6-35.5-74.6-79.2c0-43.8,33.4-79.2,74.6-79.2s74.6,35.4,74.6,79.2Z",
    fill: "#bc4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.5,698.3c0,43.7-33.4,79.2-74.6,79.2s-74.6-35.5-74.6-79.2c0-43.8,33.4-79.2,74.6-79.2s74.6,35.4,74.6,79.2Z",
    fill: "#d25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,698.3c0,29.8-22.7,54-50.8,54s-50.9-24.2-50.9-54s22.8-54,50.9-54s50.8,24.2,50.8,54Z",
    fill: "#faf2ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.7,698.3c0,12.8-9.8,23.1-21.8,23.1-12.1,0-21.8-10.3-21.8-23.1s9.7-23.1,21.8-23.1c12,0,21.8,10.3,21.8,23.1Z",
    fill: "#d25a5a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M478.8,700.6q-.1,0-.2,0c-.8-.1-1.3-.8-1.3-1.5c0-.1.9-10.1-2.8-22.6-.2-.7.2-1.5,1-1.8.7-.2,1.5.3,1.7,1c3.9,13.1,3,23.2,3,23.6-.1.8-.7,1.3-1.4,1.3Z",
    fill: "#ffab9f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M468.9,660.9c-.5,0-1-.3-1.3-.7-2.7-4.7-5.9-9.1-9.5-13-20.7-22-49.5-21-49.8-21-.8.1-1.5-.5-1.5-1.3-.1-.8.5-1.5,1.3-1.5c1.3-.1,30.4-1.1,52.1,21.9c3.7,4,7.1,8.5,9.9,13.4.4.7.1,1.6-.5,2q-.4.2-.7.2Z",
    fill: "#ffab9f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M402.8,771.9q0,0,0,0c-31.2-.5-50.1-31.2-50.3-31.6-.4-.6-.2-1.5.5-1.9.6-.4,1.5-.2,1.9.5.2.3,18.3,29.7,48,30.1.7,0,1.4.7,1.4,1.5c0,.7-.7,1.4-1.5,1.4Z",
    fill: "#ffab9f"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.855536 0 0 0.879726 189.176535-140.879711)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M409.7,700.7c-.6,0-1.1-.2-1.6-.6L304.7,600.9c-.9-.9-.9-2.3-.1-3.2.9-.9,2.3-.9,3.2-.1l103.4,99.2c.9.9.9,2.3.1,3.2-.5.4-1,.7-1.6.7Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.4,603.4q-.2,0-.4,0l-24.3-4.5c-1.2-.2-2-1.4-1.7-2.6.2-1.2,1.3-2,2.6-1.8l24.2,4.5c1.2.3,2,1.4,1.8,2.6-.2,1.1-1.1,1.8-2.2,1.8Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M318.2,613.2q-.2,0-.4-.1l-25.4-4.7c-1.2-.2-2-1.4-1.8-2.6s1.4-2,2.6-1.8l25.4,4.7c1.2.3,2,1.4,1.8,2.6-.2,1.1-1.1,1.9-2.2,1.9Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M327.9,623.1q-.2,0-.4,0l-27.9-5.3c-1.2-.2-2-1.4-1.7-2.6.2-1.2,1.4-2,2.6-1.8l27.8,5.3c1.2.2,2,1.4,1.8,2.6-.2,1.1-1.1,1.8-2.2,1.8Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M327.9,623.1c-1.1,0-2.1-.9-2.2-2l-2.2-26c-.1-1.2.8-2.3,2-2.4s2.3.8,2.4,2l2.2,26c.1,1.2-.8,2.3-2,2.4q-.1,0-.2,0Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M318.5,613c-1.2,0-2.2-.9-2.3-2.1l-.5-23.5c-.1-1.2.9-2.2,2.1-2.3c1.3,0,2.3,1,2.3,2.2l.6,23.4c0,1.3-.9,2.3-2.2,2.3q0,0,0,0Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.4,603.4q0,0,0,0c-1.3,0-2.2-1-2.2-2.2l.5-22.6c.1-1.2,1.1-2.2,2.3-2.1c1.2,0,2.2,1,2.2,2.2l-.6,22.6c0,1.2-1,2.1-2.2,2.1Z",
    fill: "#625153"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M767.6,776.3L663.9,810.5L620.4,678.2l103.7-34.1l43.5,132.2Z",
    fill: "#d25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.1,809.2l-4.2,1.3-43.5-132.3l4.2-1.2l43.5,132.2Z",
    fill: "#bc4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.1,735.6c-17.1,5.2-24.1,7.8-28.3,7.8-4.7,0-10.1-3.7-20.4-6.2-5.9-1.4-13.9-4.5-14.7-2.7-1.2,2.8,3.2,7.1,9.5,9.6c6.8,2.8,5.4,5.2,5.4,5.2s-2.1,2-11.2,5.1c-4.8,1.6-11.8,4.5-10.1,8.7c1.3,3.1,5,2.6,5,2.6s-3.3,1.9-2.1,5c1.3,3.1,5.2,2.4,5.2,2.4s-2.6,2.2-1.2,5.1c1.3,2.4,6.3,2.7,14.6.3c8.7-2.6,16.4-5.5,22.2-8.2c5.8-2.8,13.3-4.8,33.6-10.9l-7.5-23.8Z",
    fill: "url(#etvoZMJQnRd172-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706,763.7l-10.6,3.2-7.6-25.2l10.6-3.2l7.6,25.2Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.4,753.3c0,4.1-3.3,7.5-7.5,7.5-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5c4.2,0,7.5,3.4,7.5,7.5Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.9,753.3c0,3.3-2.7,6-6,6-3.2,0-5.9-2.7-5.9-6s2.7-5.9,5.9-5.9c3.3,0,6,2.6,6,5.9Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.7,733.7c0,0,2.6,21.2,11.9,33c0,0,93.3-5,111-40.7c16.5-33.6-22.4-107.7-61.2-130.9L748,656.3c9.8,15.9,18.5,31.6,24.8,46.4c0,0-35.1,21.2-68.1,31Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.7,578l-12.3,2c0,0,9.9,9.1,28.2,11.1s36.7-6.4,36.7-6.4c-3.9-1.5-7.8-2.9-11.8-4L689.7,578Z",
    fill: "url(#etvoZMJQnRd177-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M924.6,481c0,34.1-27.7,61.8-61.8,61.8s-61.8-27.7-61.8-61.8c0-34.2,27.7-61.8,61.8-61.8s61.8,27.6,61.8,61.8Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.8,481c0,29.8-24.2,54-54,54s-54-24.2-54-54c0-29.9,24.2-54.1,54-54.1s54,24.2,54,54.1Z",
    fill: "#faf2ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.8,481l.2-49.2c26.9.1,49,22.3,49,49.2c0,5-.8,10-2.3,14.8L862.8,481Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.6,481c0,2.1-1.7,3.7-3.8,3.7s-3.8-1.6-3.8-3.7s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M862.8,531.4c-.8,0-1.5-.6-1.5-1.4v-7.6c0-.8.7-1.5,1.5-1.5s1.5.7,1.5,1.5v7.6c0,.8-.7,1.4-1.5,1.4Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M862.8,441.2c-.8,0-1.5-.6-1.5-1.4v-7.8c0-.8.7-1.5,1.5-1.5s1.5.7,1.5,1.5v7.8c0,.8-.7,1.4-1.5,1.4Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M821.4,482.5h-7.6c-.8,0-1.5-.7-1.5-1.5s.7-1.5,1.5-1.5h7.6c.8,0,1.5.7,1.5,1.5s-.7,1.5-1.5,1.5Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M911.8,482.5h-7.8c-.8,0-1.5-.7-1.5-1.5s.7-1.5,1.5-1.5h7.8c.8,0,1.5.7,1.5,1.5s-.7,1.5-1.5,1.5Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M828.2,517.1c-.4,0-.8-.2-1.1-.4-.6-.6-.6-1.6,0-2.1l2.6-2.6c.5-.6,1.5-.6,2.1,0c.5.6.5,1.5,0,2.1l-2.6,2.6c-.3.2-.6.4-1,.4Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M894.8,450.5c-.4,0-.8-.1-1.1-.4-.6-.6-.6-1.5,0-2.1l2.7-2.7c.6-.6,1.5-.6,2.1,0s.6,1.5,0,2.1l-2.7,2.7c-.3.3-.7.4-1,.4Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M830.7,450.4c-.4,0-.8-.2-1-.5l-2.6-2.5c-.6-.6-.6-1.5,0-2.1s1.5-.6,2.1,0l2.6,2.5c.5.6.5,1.5,0,2.1-.3.3-.7.5-1.1.5Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M897.4,517.1c-.3,0-.7-.2-1-.4l-2.7-2.7c-.6-.6-.6-1.6,0-2.1.6-.6,1.5-.6,2.1,0l2.7,2.7c.6.5.6,1.5,0,2.1-.3.2-.7.4-1.1.4Z",
    fill: "#625153"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M862.8,482.5c-.4,0-.8-.2-1.1-.5-.4-.5-.5-1.1-.3-1.6l17.8-42c.4-.8,1.2-1.1,2-.8.7.3,1.1,1.2.8,1.9l-16.6,39.1l23.2-7c.8-.2,1.6.2,1.8,1c.3.8-.2,1.6-1,1.9l-26.2,7.9q-.2.1-.4.1Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M716.6,768.2c-.5,0-.9-.2-1.2-.6-9.4-12-12-32.9-12.1-33.7-.1-.7.3-1.4,1-1.6c32.5-9.6,67.4-30.6,67.8-30.8.7-.4,1.5-.2,1.9.5.5.7.2,1.5-.4,1.9-.4.3-34.8,20.9-67.3,30.8.7,4.6,3.7,21.3,11.4,31.2.5.6.4,1.5-.3,2q-.4.3-.8.3Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M772.6,703.9c-.4,0-.8-.1-1.1-.4-.4-.5-.5-1.3-.1-1.8.4-.6,9.5-13.3,23.9-11.8.8.1,1.4.8,1.3,1.6s-.8,1.4-1.6,1.3c-6.6-.7-12,2.1-15.8,5c6.7-2.5,17-5,28.2-2.3.8.2,1.2,1,1,1.8-.1.7-.9,1.2-1.7,1-17.4-4.3-33.2,5.3-33.4,5.4q-.3.2-.7.2Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M772.9,703.2c-.5,0-1-.3-1.2-.8-.2-.3-15.3-30.8-21.7-38.7-.5-.6-.5-1.5.2-2c.6-.5,1.5-.4,2,.2c6.7,8.2,21.4,37.9,22,39.2.4.7.1,1.6-.6,1.9q-.3.2-.7.2Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M757.7,674.6q-.2,0-.5-.1l-7.4-3c-.7-.2-1.1-1.1-.8-1.8s1.1-1.1,1.8-.8l7.5,3c.7.3,1.1,1.1.8,1.8-.3.6-.8.9-1.4.9Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M645.3,767.1c-.6,0-1.2-.3-1.4-.9-.3-.7.1-1.6.8-1.8l5.4-2.1c.7-.2,1.5.1,1.8.9.3.7-.1,1.5-.8,1.8l-5.3,2q-.3.1-.5.1Z",
    fill: "#e2807c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M648.4,774.5c-.6,0-1.1-.3-1.4-.9-.2-.7.1-1.6.9-1.9l4.5-1.8c.8-.2,1.6.1,1.9.9.3.7-.1,1.5-.8,1.8l-4.6,1.8q-.3.1-.5.1Z",
    fill: "#e2807c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M631.6,660.5q-.4,0-.7-.2c-3.8-2.5-5-11.5-5.1-12.5-.1-.8.4-1.5,1.2-1.6s1.5.4,1.6,1.2c.4,3.4,1.8,9.2,3.8,10.5.7.4.9,1.3.4,2-.2.4-.7.6-1.2.6Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M604.6,687.2c-.7,0-1.2-.4-1.4-1-.1-.2-4.8-17.1-15.5-25.6-.5-.4-.6-1.1-.4-1.7.3-.6.9-.9,1.5-.9.4.1,9.6,1.3,17.3,11c.5.6.4,1.5-.3,2-.6.5-1.5.4-2-.3-3.2-4-6.8-6.5-9.7-7.9c8.1,9.4,11.7,22,11.8,22.6.3.8-.2,1.6-.9,1.8q-.2,0-.4,0Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M719.3,709.6l-56.1,18.5-9-27.3l56.1-18.5l9,27.3Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M710.3,598.6c-24.5,0-35.8-11.3-36.4-11.9s-.6-1.5,0-2.1c.6-.5,1.5-.5,2,.1.2.1,16.8,16.6,53.1,9c.8-.2,1.5.3,1.7,1.1.2.7-.3,1.5-1.1,1.7-7.2,1.5-13.6,2.1-19.3,2.1Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M723.4,603.4c-.8,0-1.4-.6-1.5-1.4c0-.7.6-1.4,1.4-1.4.1,0,11.1-.6,18.2-4.3.7-.4,1.5-.1,1.9.6s.1,1.5-.6,1.9c-7.6,4.1-18.9,4.6-19.4,4.6q0,0,0,0Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M406.6,474.4c-2.8-1.5-5.6-3.2-8.2-4.9l1.8-2.8c2.6,1.7,5.3,3.3,8,4.7l-1.6,3Zm-16.1-10.2c-2.5-1.8-5-3.8-7.4-5.9l2.2-2.5c2.3,2,4.8,3.9,7.2,5.7l-2,2.7Zm-14.4-12.3c-2.3-2.2-4.5-4.5-6.6-6.9l2.6-2.2c2,2.3,4.1,4.6,6.3,6.7l-2.3,2.4Zm-12.5-14.2c-2-2.5-3.8-5.2-5.5-7.8l2.8-1.8c1.7,2.6,3.5,5.1,5.3,7.6l-2.6,2Zm-10.3-16c-1.5-2.8-2.9-5.7-4.2-8.5l3.1-1.4c1.2,2.8,2.6,5.6,4,8.3l-2.9,1.6Zm-7.6-17.4c-1.1-3-2-6.1-2.7-9.1l3.2-.8c.8,2.9,1.6,5.9,2.6,8.8l-3.1,1.1Zm-4.5-18.5c-.5-3.1-.8-6.3-1-9.4l3.4-.2c.1,3,.4,6.1.9,9.1l-3.3.5Zm2.3-18.8l-3.3-.2c.1-3.1.4-6.3.9-9.5l3.3.5c-.5,3-.7,6.1-.9,9.2Zm2.6-18.2l-3.2-.8q.4-1.8.9-3.7.8-2.8,1.8-5.5l3.1,1.1q-.9,2.6-1.6,5.4-.5,1.7-1,3.5Zm6-17.5L349,330c1.4-3,2.8-5.8,4.4-8.5l2.9,1.6c-1.5,2.6-2.9,5.4-4.2,8.2Zm9.2-15.8l-2.6-2c1.9-2.6,4-5.1,6.2-7.3l2.4,2.3c-2.1,2.2-4.1,4.5-6,7Zm108.2-.3l-1.6-3q1.8-.9,3.5-3.2.9-1.3,1-2.6l3.3.1q-.1,2.4-1.6,4.5-2.1,2.9-4.6,4.2ZM459,313.4c-2.1-1.9-4-4.7-5.6-8.3l3.1-1.3c1.3,3.1,3,5.6,4.7,7.2l-2.2,2.4Zm-84.9-11.1l-2.1-2.7c2.5-1.9,5.1-3.8,7.9-5.4l1.7,2.9c-2.6,1.5-5.1,3.3-7.5,5.2Zm94.5-2.7c-1.9-1.7-4.4-3.4-7.4-5l1.5-2.9c3.3,1.7,6,3.5,8.1,5.4l-2.2,2.5Zm-18-3.8q-.5-2.8-.8-5.7-2.9-.9-5.8-1.5l.7-3.3q2.4.6,4.8,1.2q0-.1,0-.3l3.3-.1q0,.7.1,1.5.5.1,1,.3l-.8,2.3q.3,2.5.8,4.9l-3.3.7Zm-60.8-2.9l-1.3-3c2.8-1.3,5.9-2.4,9-3.3l.9,3.2c-2.9.9-5.8,1.9-8.6,3.1Zm17.5-5.2l-.5-3.3c3.1-.6,6.2-1,9.4-1.2l.3,3.3c-3.1.3-6.2.6-9.2,1.2Zm27.6-.7c-3.1-.4-6.1-.6-9.2-.7l.1-3.3c3.1.1,6.3.3,9.5.7l-.4,3.3Zm18.2-10.1l-3.4-.3c.4-3.2.9-6.4,1.7-9.5l3.2.8c-.7,3-1.2,6-1.5,9Zm4.3-17.7l-3.1-1.2c1.2-3,2.7-5.9,4.3-8.6l2.9,1.7c-1.6,2.6-2.9,5.3-4.1,8.1Zm184-4.3c-2.3-2.1-4.6-4.1-7-6.1l2.1-2.6c2.5,2,4.9,4.1,7.2,6.2l-2.3,2.5ZM466.6,243.6l-2.6-2.1c2-2.5,4.2-4.9,6.5-7l2.3,2.4c-2.2,2.1-4.3,4.3-6.2,6.7Zm160.4-.5c-2.4-1.9-5-3.7-7.5-5.4l1.8-2.8c2.6,1.8,5.2,3.6,7.8,5.5l-2.1,2.7Zm-15.5-10.4c-2.7-1.6-5.4-3.1-8.1-4.5l1.6-3c2.7,1.5,5.5,3,8.2,4.7l-1.7,2.8Zm-131.7-1.6l-1.9-2.7c2.6-1.8,5.3-3.5,8.1-5.1l1.6,3c-2.7,1.4-5.3,3.1-7.8,4.8ZM595.1,224c-2.9-1.3-5.7-2.4-8.6-3.5l1.2-3.1c2.9,1,5.9,2.3,8.8,3.6l-1.4,3Zm-99.2-1.7l-1.2-3.1c2.8-1.2,5.8-2.3,8.9-3.2l1,3.2c-3,.9-5.9,2-8.7,3.1Zm81.8-4.8c-3-.8-6-1.6-8.9-2.1l.6-3.3c3,.6,6.2,1.3,9.3,2.2l-1,3.2Zm-64.2-.6l-.7-3.3c3-.7,6.1-1.2,9.3-1.7l.5,3.3c-3.1.5-6.2,1-9.1,1.7Zm18.3-2.7l-.3-3.4c3.1-.2,6.2-.4,9.4-.5l.1,3.3c-3.1.1-6.2.3-9.2.6Zm27.8-.2q-2.7-.3-5.3-.3-2-.1-4-.1l.1-3.4q2,0,4,.1q2.7.1,5.5.4l-.3,3.3Z",
    fill: "#a8c7bf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M651.4,253.8l.4,9.6-8.1-1.3l3.2,13.7l35.6,14.4-23.6-36.4h-7.5Z",
    fill: "#90b3ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.9,274.1l21.8-12L682.6,290l-60.7-15.9Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.5,231.1l-10.1,22.7l31.1,36.4-21-59.1Z",
    fill: "#a8c7bf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M706,657.5c-.6,0-1.2-.4-1.4-1-.2-.8.2-1.6.9-1.8l10.9-3.5c.8-.3,1.6.1,1.8.9.2.7-.2,1.5-.9,1.8l-10.9,3.5q-.2.1-.4.1Z",
    fill: "#ffab9f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M634.7,680.7c-.6,0-1.2-.3-1.4-.9-.2-.8.2-1.6.9-1.8l55.7-18.2c.8-.3,1.6.1,1.8.9.3.7-.1,1.5-.9,1.8l-55.7,18.2q-.2,0-.4,0Z",
    fill: "#ffab9f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills8);
export default __webpack_public_path__ + "static/media/skills8.87d11571f0d8c9a6cbc7a76f73860fc4.svg";
export { ForwardRef as ReactComponent };